// You still need to register Vuetify itself
// src/plugins/vuetify.js

import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';
import theme from '../config/config-ui';
import '@/assets/custom-fonts/open-access/css/open-access.css';
import '@/assets/custom-fonts/avenir/stylesheet.css';
import '@/assets/stylus/main.styl';

const CUSTOM_ICONS = {
    login: 'icon-login',
    'login-header': 'icon-luxtag-header-login',
    qrcode: 'fas fa-qrcode',
};

Vue.use(Vuetify, {
    iconfont: 'fa',
    icons: CUSTOM_ICONS,
    directives: {
        Ripple,
    },
    theme,
});
